import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  IconButton,
  Chip,
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListSubheader,
} from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { axiosInstance } from "../../../services/axiosInstance";
import { endpoints } from "../../../services/endpoint";
import { synthesizeSpeech, fetchPollyVoices } from "../../../services/pollyService";
import axios from "axios";
import "./addPrompts.css";
import CloseIcon from "@mui/icons-material/Close";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
const AddPromptsPage = ({ onClose, onProfileAdded }) => {
  const [Name, setName] = useState("");
  const [Description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const [recordedAudio, setRecordedAudio] = useState(null);
  const [timer, setTimer] = useState(0);
  const [timerInterval, setTimerInterval] = useState(null);
  const [selectedOption, setSelectedOption] = useState("polly");
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [key, setKey] = useState("");
  const [value, setValue] = useState("");
  const [tags, setTags] = useState([]);
  const [showTags, setShowTags] = useState(false);
  const [loading, setLoading] = useState(false);
  const [actionClicked, setActionClicked] = useState(null);
  const [cancelLoading, setCancelLoading] = useState(false);
  const email = localStorage.getItem("Email");
  const instanceAlias = localStorage.getItem("instanceName");
  const instanceId = localStorage.getItem("InstanceId");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");

  const username = localStorage.getItem("username");
  const region = localStorage.getItem("Region");
  const EncryptedInstanceId = localStorage.getItem("EncryptedId")
  useEffect(() => {
    return () => {
      if (timerInterval) clearInterval(timerInterval);
    };
  }, [timerInterval]);
  const [text, setText] = useState("");
  useEffect(() => {
    localStorage.setItem("text", text);
  }, [text]);

  const [isPlaying, setIsPlaying] = useState(false);
  const [audioBase64, setAudioBase64] = useState("");
  const [selectedVoice, setSelectedVoice] = useState("Joanna");
  const [pollyError, setPollyError] = useState("");
  const [pollyAudioUrl, setPollyAudioUrl] = useState(null);
  const [pollyVoices, setPollyVoices] = useState([]);

  useEffect(() => {
    fetchPollyVoices().then(setPollyVoices);
  }, []);

  const handlePlay = async () => {
    if (!text.trim()) return;

    setIsPlaying(true);
    setPollyError("");

    try {
      const base64Audio = await synthesizeSpeech(text, selectedVoice);
      setAudioBase64(base64Audio);

      // Create a playable URL for preview
      const byteChars = atob(base64Audio);
      const byteNumbers = new Uint8Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i++) {
        byteNumbers[i] = byteChars.charCodeAt(i);
      }
      const blob = new Blob([byteNumbers], { type: "audio/wav" });
      const url = URL.createObjectURL(blob);
      setPollyAudioUrl(url);

      // Play the audio automatically
      const audioToPlay = new Audio(url);
      audioToPlay.play();
    } catch (err) {
      console.error("Polly synthesis error:", err);
      setPollyError(
        "Failed to generate audio. Please check your AWS Polly configuration."
      );
    } finally {
      setIsPlaying(false);
    }
  };

  // ── File Handlers ──
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (!selectedFile.name.toLowerCase().endsWith(".wav")) {
        setErrorMessage("Please select a valid .wav file.");
        setFile(null);
        setAudioBase64("");
        return;
      }
      setErrorMessage("");
      setFile(selectedFile);
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1]; // Remove data URL prefix
        setAudioBase64(base64String);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
    setErrorMessage("");
    setErrors({});
  };

  const handleNameChange = (e) => setName(e.target.value);
  const handleDescriptionChange = (e) => setDescription(e.target.value);
  const handleKeyDown = (e) => {
    if (e.key === "Enter") e.preventDefault();
  };

  const handleAddTag = () => {
    if (tags.length < 50) {
      setTags([...tags, { key, value }]);
      setKey("");
      setValue("");
    }
  };

  const handleDeleteTag = (tagToDelete) => {
    setTags(tags.filter((tag) => tag !== tagToDelete));
  };

  const toggleShowTags = () => setShowTags(!showTags);

  const validateForm = () => {
    const newErrors = {};
    if (!Name) newErrors.Name = "Name is required";
    if (!Description) newErrors.Description = "Description is required";
    if (selectedOption === "upload" && !file) newErrors.audio = "Please upload a .wav file";
    if (selectedOption === "record" && !recordedAudio) newErrors.audio = "Please record audio first";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCancel = () => {
    setActionClicked("cancel");
    setCancelLoading(true);
    setTimeout(() => {
      onClose();
    }, 300);
    setActionClicked(null);
  };

  const validateFields = () => {
    const newErrors = {};

    if (!Name) newErrors.Name = "Name is required";
    if (!Description) newErrors.Description = "Description is required";

    if (selectedOption === "polly") {
      if (!text.trim()) newErrors.Context = "Please enter context";
    } else if (selectedOption === "upload") {
      if (!file) newErrors.audio = "Please upload a .wav file";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchPrompts = async () => {
    const body = {
      action: "list",
      ID: EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region,
      InstanceAlias: instanceAlias,
    };

    try {
      const response = await axiosInstance.post(endpoints.promptsDisplay.promptlist, body);
      if (response.data.statusCode === 200) {
        const parsed = JSON.parse(response.data.body);
        const promptList = parsed.prompts;

        if (Array.isArray(promptList)) {
          return promptList.map((item) => ({
            name: item.Name || "Unnamed Prompt",
            id: item.Id || "-",
            arn: item.ARN || "-",
            description: item.Description || "No description",
            tags: item.Tags && Object.keys(item.Tags).length > 0 ? item.Tags : {},
            voice: item.Voice || "Joanna",
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching prompts list:", error);
    }

    return [];
  };

  const handleSave = async () => {
    if (!validateFields()) {
      setErrorMessage("Please fill out all required fields.");
      return;
    }
    setActionClicked("save");
    setLoading(true);
    setErrorMessage("");

    try {
      let finalAudioBase64 = audioBase64;

      if (selectedOption === "polly") {
        // Generate immediately before saving to ensure latest text translation
        if (!text.trim()) {
          throw new Error("Context is required for Polly generation.");
        }
        finalAudioBase64 = await synthesizeSpeech(text, selectedVoice);
      } else if (selectedOption === "upload") {
        if (!finalAudioBase64) {
          throw new Error("No valid .wav file loaded.");
        }
      }

      // Convert the Tags array to an object (dictionary)
      const tagsObject = {};
      tags.forEach((tag) => {
        tagsObject[tag.key] = tag.value;
      });

      const payload = {
        ID: EncryptedInstanceId,
        region: region,
        awsAccount: customerAWSAccountId,
        InstanceAlias: instanceAlias,
        UserName: username,
        Email: email,
        BucketName: `${customerAWSAccountId}-${instanceAlias}-prompts`,
        Name: Name,
        action: "create",
        object_key: Name,
        file_content: finalAudioBase64,
        Description: Description,
        ContextText: selectedOption === "polly" ? text : undefined,
        Tags: Object.keys(tagsObject).length > 0 ? tagsObject : undefined,
      };

      const response = await axiosInstance.post(
        endpoints.promptPlay.promptlist,
        payload,
        {
          maxBodyLength: Infinity,
          maxContentLength: Infinity,
          timeout: 30000,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setLoading(false);

      if (response.data.statusCode === 200) {
        const responseData = JSON.parse(response.data.body);

        if (selectedOption === "polly") {
          try {
            await axios.post(
              "https://grj87qmm19.execute-api.us-east-1.amazonaws.com/Test/UpdatePromptContext",
              {
                action: "UpdateContext",
                PromptName: Name,
                ContextText: text,
                Voice: selectedVoice,
              },
              {
                headers: { "Content-Type": "application/json" },
              }
            );
            console.log("Context updated successfully");
          } catch (err) {
            console.error("Error updating context:", err);
          }
        }

        const newPromptData = {
          Name: payload.Name,
          Description: payload.Description,
          region: payload.region,
          awsAccount: payload.awsAccount,
          InstanceAlias: payload.InstanceAlias,
          UserName: payload.UserName,
          Email: payload.Email,
          BucketName: payload.BucketName,
          object_key: payload.object_key,
          Tags: payload.Tags,
          CreatedDate: new Date().toISOString(),
          Status: "Active",
          FileType: "Generated",
          ...responseData,
        };

        if (onProfileAdded) {
          const updatedList = await fetchPrompts();
          onProfileAdded(updatedList);
        }
        onClose();
        console.log("Prompt created successfully:", newPromptData);
      } else {
        setErrorMessage("Failed to save prompt. Please try again.");
      }
    } catch (err) {
      console.error("Save error:", err);

      let errorMsg = "Failed to save prompt. Please try again.";
      if (err.code === "ECONNABORTED") {
        errorMsg = "Request timed out. Please try again.";
      } else if (err.response?.status === 413) {
        errorMsg = "File too large. Please use a smaller file.";
      } else if (err.response?.data?.body) {
        try {
          const errorBody = JSON.parse(err.response.data.body);
          if (
            errorBody.error &&
            errorBody.error.includes("Invalid audio file format")
          ) {
            errorMsg =
              "Invalid audio file format. Please ensure you're using a valid .wav file with proper encoding.";
          } else if (errorBody.message) {
            errorMsg = errorBody.message;
          }
        } catch (parseError) {
          console.error("Error parsing error response:", parseError);
        }
      }

      setErrorMessage(errorMsg);
    } finally {
      setLoading(false);
      setActionClicked(null);
    }
  };

  return (

    <Container className="addprompts-content-container">
      <Box display="flex" flexDirection="column" alignItems="flex-start" mb={2} gap={1}>
        {/* Back Arrow in a circular button */}
        <IconButton
          onClick={onClose}
          size="medium"
          sx={{
            border: "1px solid #ccc",
            borderRadius: "50%",
            padding: 1,
            bgcolor: "#f5f5f5",
            "&:hover": { bgcolor: "#e0e0e0" }
          }}
        >
          <ArrowBackIcon />
        </IconButton>

        {/* Title */}
        <Typography variant="h4" className="phone-text">
          Add Prompt
        </Typography>
      </Box>
      <div className="addprompts-form-section">
        <h3>Prompt Details</h3>
        <div className="addprompts-form-fields">
          <TextField
            label="Name"
            placeholder="Enter Name"
            required
            value={Name}
            onChange={handleNameChange}
            onKeyDown={handleKeyDown}
            helperText={errors.Name}
            error={!!errors.Name}
            className="addprompts-form-field"
          />
          <TextField
            label="Description"
            placeholder="Enter description"
            required
            value={Description}
            onChange={handleDescriptionChange}
            helperText={errors.Description}
            error={!!errors.Description}
            className="addprompts-form-field"
          />
        </div>

        <Box sx={{ mt: 3, mb: 3, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' }, gap: 4 }}>
          <Typography variant="h6" className="audioheading" sx={{ mb: 0, mt: 0 }}>
            Audio Generation Mode
          </Typography>
          <div className="radio-group" style={{ margin: 0, display: "flex", gap: "20px" }}>
            <label style={{ display: "flex", alignItems: "center", cursor: "pointer", margin: 0 }}>
              <input
                type="radio"
                value="polly"
                checked={selectedOption === "polly"}
                onChange={handleOptionChange}
                style={{ marginRight: "6px" }}
              />
              Generate with Amazon Polly
            </label>
            <label style={{ display: "flex", alignItems: "center", cursor: "pointer", margin: 0 }}>
              <input
                type="radio"
                value="upload"
                checked={selectedOption === "upload"}
                onChange={handleOptionChange}
                style={{ marginRight: "6px" }}
              />
              Upload .WAV File
            </label>
          </div>
        </Box>

        <div className="space-y-4" style={{ width: "100%" }}>
          {selectedOption === "polly" && (
            <>
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', backgroundColor: "#f9fafb", borderRadius: "8px", padding: "16px" }}>
                <TextField
                  label="Context"
                  value={text}
                  required
                  onChange={(e) => setText(e.target.value)}
                  placeholder="Enter text to convert to speech..."
                  className="addprompts-form-field"
                  error={!!errors.Context}
                  helperText={errors.Context}
                  sx={{ minWidth: 200, maxWidth: 300, flex: 1 }}
                />

                <FormControl sx={{ minWidth: 200, maxWidth: 300, flex: 1 }}>
                  <InputLabel id="polly-voice-label">Polly Voice</InputLabel>
                  <Select
                    labelId="polly-voice-label"
                    value={selectedVoice}
                    label="Polly Voice"
                    onChange={(e) => setSelectedVoice(e.target.value)}
                    MenuProps={{ PaperProps: { style: { maxHeight: 300 } } }}
                  >
                    {pollyVoices.map((v) => (
                      <MenuItem key={v.id} value={v.id}>
                        {v.name} - {v.language}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <IconButton
                    onClick={handlePlay}
                    disabled={!text.trim() || isPlaying}
                    color="primary"
                    sx={{ backgroundColor: "#e3f2fd", '&:hover': { backgroundColor: "#bbdefb" }, p: 1.5 }}
                  >
                    {isPlaying ? <CircularProgress size={24} /> : <VolumeUpIcon />}
                  </IconButton>
                </Box>
              </Box>

              {pollyError && (
                <Typography variant="body2" color="error" sx={{ mt: 1, pl: 2 }}>
                  {pollyError}
                </Typography>
              )}
            </>
          )}

          {selectedOption === "upload" && (
            <div className="upload-section" style={{ backgroundColor: "#f9fafb", borderRadius: "8px", padding: "16px" }}>
              {errors.audio && <p className="error-message" style={{ color: "red", marginTop: 0 }}>{errors.audio}</p>}
              <Typography variant="body2" sx={{ mb: 2 }}>
                Choose a <b>.wav</b> file to save as a prompt.
              </Typography>
              <input
                type="file"
                accept=".wav"
                onChange={handleFileChange}
                style={{ display: "block", marginBottom: "10px" }}
              />
              {file && <Typography variant="body2" color="primary">Selected file: {file.name}</Typography>}
            </div>
          )}
        </div>

        {errorMessage && (
          <div style={{ color: "red", margin: "10px 0", padding: "0 16px" }}>{errorMessage}</div>
        )}

        <div className="addprompts-form-section">
          <h3>Prompt Settings</h3>
          <Box className="addprompt-boxstyling" onClick={toggleShowTags}>
            <Typography className="addprompt-advancedtext">
              Show advanced settings
            </Typography>
            <IconButton>
              {showTags ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            </IconButton>
          </Box>

          {showTags && (
            <>
              <Typography className="addprompt-tagstext">Tags (Optional)</Typography>
              <Typography className="tagsbelowtext">
                Add tags to organize and control access to prompts.{" "}
                <a
                  href="https://docs.aws.amazon.com/connect/latest/adminguide/tagging.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="addprompt-learnstyle"
                >
                  Learn More.
                </a>
              </Typography>
              <Box className="addprompt-tags-container">
                <Box className="addprompt-input-container">
                  <TextField
                    label="Key"
                    variant="filled"
                    size="small"
                    value={key}
                    onChange={(e) => setKey(e.target.value)}
                    className="addprompt-input-field"
                  />
                  <TextField
                    label="Value"
                    variant="filled"
                    size="small"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    className="addprompt-input-field"
                    disabled={!key}
                  />
                  <Button
                    variant="outlined"

                    onClick={handleAddTag}
                    disabled={!key || !value}
                  >
                    Add
                  </Button>
                </Box>

                {tags.length > 0 && (
                  <Box className="addprompt-tags-display">
                    <Typography variant="subtitle1">Selected tags</Typography>
                    <Typography variant="body2">
                      You can add up to {50 - tags.length} more tags
                    </Typography>
                    <Box className="addprompt-tags-list">
                      {tags.map((tag, index) => (
                        <Chip
                          key={index}
                          label={`${tag.key}: ${tag.value}`}
                          onDelete={() => handleDeleteTag(tag)}
                          className="addprompt-tag-chip"
                        />
                      ))}
                    </Box>
                  </Box>
                )}
              </Box>
            </>
          )}
        </div>

        <div className="buttons-addprompts">
          <Button onClick={handleCancel}
            disabled={actionClicked === "save" || cancelLoading}
          >
            <span className="adduser-button-content">
              {actionClicked === "cancel" ? (
                <CircularProgress size={18} style={{ color: "red" }} />
              ) : (
                "Cancel"
              )}
            </span>
          </Button>
          <Button onClick={handleSave}


            variant="contained"
            disabled={actionClicked === "cancel" || loading}
          >
            <span className="adduser-button-content">
              {actionClicked === "save" ? (
                <CircularProgress size={18} style={{ color: "white" }} />
              ) : (
                "Save"
              )}
            </span>
          </Button>
        </div>
        <br />
      </div>
    </Container>

  );
};

export default AddPromptsPage;